import { colors } from 'modules/app/styles'
import Avatar from 'modules/auth/components/Avatar'
import { CustomButton } from 'modules/auth/styles'
import { Accordion, AccordionItem } from 'react-accessible-accordion'
import { Dropdown } from 'reactstrap'
import styled from 'styled-components'
import { CONSTANTS } from 'utils/helpers'

// Published page styles
export const PageMeta = styled.div`
  padding: 6px 16px;
  border: 1px solid ${colors['light-blue-200']};
  background: ${colors['lightest-blue']};
  line-height: 24px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (min-width: 576px) {
    flex-direction: row;
    align-items: center;
  }
  .user-info {
    display: flex;
    align-items: center;
    .user-name {
      margin-left: 12px;
      line-height: 1.5;
      span {
        font-size: 80%;
      }
    }
  }

  .action-buttons {
    margin-left: auto;
    margin-top: 30px;
    @media (min-width: 576px) {
      margin-top: 0;
    }
  }
`

export const Comment = styled.div`
  background: none;
  margin-bottom: 5px;
  padding: 0 0 12px 16px;
  border-left: 2px solid transparent;
  &:hover {
    background: #fff;
    border-left-color: ${colors['main-blue']};
  }
  &.reply {
    margin-bottom: 0;
    position: relative;
    border-bottom: none;
    padding: 0 0 0 6px;
    border-left: none;
    &:last-of-type {
      border-bottom: none;
      padding-bottom: 0;
    }
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 2px;
      background: ${colors['light-blue-300']};
    }
    .comment-box {
      padding: 5px 8px;
    }
  }

  .comment-box {
    padding: 12px 12px 12px 0;
    position: relative;
    .comment {
      white-space: pre-wrap;
      a[href] {
        width: 100%;
        overflow: hidden;
        display: inline-block;
        word-break: break-all;
      }
    }
    .meta {
      display: flex;
      align-items: center;
      h5 {
        margin: 0;
        margin-left: 5px;
        font-size: 12px;
        -webkit-text-fill-color: ${colors['text-secondary']};
        color: ${colors['text-secondary']};
        line-height: 1;
        text-transform: capitalize;
      }
      small {
        display: inline-block;
        color: #8c8c8c;
        line-height: 1;
        &:before {
          content: '\\2022';
          display: inline-block;
          margin-right: 5px;
        }
      }
      p {
        color: #222;
        font-weight: 300;
      }
    }
    .more-button-dropdown {
      position: absolute;
      right: 8px;
      top: 5px;
      button.toggle {
        @media (max-width: 1024px) {
          display: flex;
        }
        @media (min-width: 1025px) {
          display: none;
        }
      }
    }

    &:hover .more-button-dropdown button.toggle,
    &.show_delete .more-button-dropdown button.toggle {
      display: flex;
    }
  }
`

export const CommentActions = styled.div`
  display: flex;
  align-items: center;
  .action {
    a {
      font-size: 0.8rem;
      color: ${colors['main-text']};
      font-weight: 600;
      display: flex;
      align-items: center;
      &:hover {
        color: ${colors['main-blue']};
      }
      .expander {
        width: 16px;
        height: 16px;
        line-height: 1;
        text-align: center;
        border-radius: 16px;
        &.active {
          background: ${colors['light-blue-300']};
        }
      }
    }
  }
`

export const CommentInput = styled.div`
  .contentEditable {
    height: auto;
    min-height: 55px;
    position: relative;
    &:before {
      content: 'write here... [shift + enter to new line]';
      position: absolute;
      color: #ababab;
      font-size: 0.9rem;
    }
    &.notEmpty:before {
      display: none;
    }
  }
`
export const CommentSendButton = styled(CustomButton)`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
`

export const PageContentTableStyled = styled.div`
  background-color: ${colors['lightest-blue']};
  overflow: auto;
  z-index: 7;
  &.active {
    display: block;
  }
  .table-of-contents-title {
    margin-bottom: 0;
    color: ${colors['main-text']};
    font-size: 14px;
    font-weight: 600;
  }
  .table-of-contents {
    padding: 20px 0;
    margin-bottom: 0;
    max-height: calc(100% - 54px);
    overflow: auto;
    li {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-top: 16px;
      a {
        color: #686868;
        &:hover {
          color: #000;
        }
      }
      &:first-of-type {
        margin-top: 0 !important;
      }
      &.h1 {
        font-size: 14px;
      }
      &.h2,
      &.h3,
      &.h4,
      &.h5,
      &.h6 {
        font-size: 12px;
      }

      &.level-0 {
        padding-left: 0rem;
      }
      &.level-1 {
        padding-left: 1rem;
      }
      &.level-2 {
        padding-left: 2rem;
      }
      &.level-3 {
        padding-left: 3rem;
      }
      &.level-4 {
        padding-left: 4rem;
      }
      &.level-5 {
        padding-left: 5rem;
      }
      &.level-6 {
        padding-left: 6rem;
      }
    }
  }
`
export const PageContentTableButton = styled.div`
  position: absolute;
  z-index: 1;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 11px;
  color: #7f82a1;
  right: 15px;
  top: 500px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  z-index: 6;
  &:hover {
    color: ${colors['main-text']};
  }
  .chevron-right {
    transform: rotate(180deg);
  }
  &.active {
    .chevron-right {
      transform: rotate(-90deg);
    }
  }
`

export const ControlPanel = styled.div`
  max-width: 0;
  min-width: 0;
  overflow: hidden;
  background: ${colors['lightest-blue']};
  border-radius: 0;
  position: sticky;
  top: 54px;
  height: 100%;
  z-index: 1;
  transition: 0.25s ease-out;
  @media (min-width: 576px) {
    z-index: 1;
    border-radius: 8px;
    height: calc(100vh - 85px);
    overflow-y: auto;
  }
  @media (max-width: 1024px) {
    position: absolute;
    top: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 0.5rem 2rem -1rem rgba(0, 0, 0, 0.3) !important;
  }
  &.active {
    border: 1px solid rgba(205, 205, 231, 0.5);
    max-width: 100%;
    min-width: 100%;
    @media (min-width: 576px) {
      max-width: 286px;
      min-width: 286px;
    }
  }

  & > div {
    width: 100vw;
    @media (min-width: 576px) {
      width: 286px;
    }
  }
`
export const ControlPanelButton = styled(CustomButton)`
  background: #fff;
  padding: 0 10px;
  position: absolute;
  top: 0px;
  @media (min-width: 576px) {
    padding: 5px 15px;
    top: ${props => props.iscoverorcatshowing ? '207px' : '60px'};
  }
  right: 0;
  z-index: 1;
  border: none;
  &:hover,
  &:active,
  &:focus {
    border: none;
    outline: none;
    background: ${colors['light-blue-200']} !important;
  }
  &:hover {
  }
`

export const ControlPanelAction = styled.div`
  display: flex;
  justify-content: between;
  align-items: center;
`
export const ControlPanelBack = styled.a`
  color: ${colors['main-text']};
  margin: 10px;
  display: flex;
  align-items: center;
  &:hover {
    color: ${colors['main-blue']};
    svg {
      stroke: ${colors['main-blue']};
    }
  }
`
export const ControlPanelClose = styled.button`
  background: none;
  border: none;
  text-align: center;
  border-radius: 25px;
  margin: 10px;
  margin-left: auto;
  &:focus {
    outline: none;
  }
  &:hover {
    background: ${colors['light-blue-200']};
  }
`

export const ControlPanelHeading = styled.div`
  padding: 10px 24px;
  font-weight: 600;
  font-size: 18px;
  @media (min-width: 576px) {
    padding: 24px 16px;
    padding-top: 15px;
  }
`

export const ControlPanelAccordion = styled(Accordion)`
  .accordionItemButton {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid ${colors['light-blue-200']};
    position: relative;
    & > svg {
      width: 24px;
      height: 24px;
    }
    &-title {
      font-size: 16px;
      margin-left: 8px;
    }

    &:hover,
    &.expanded {
      background: #fff;
    }
    &:hover:before,
    &.expanded:before {
      content: '';
      left: 0;
      top: 0;
      bottom: 0;
      width: 2px;
      position: absolute;
      background: ${colors['main-blue']};
    }

    .expandButton {
      svg {
        fill: ${colors['main-text']};
      }
    }
  }
  .AccordionItemPanel {
    background: ${colors['light-blue-200-100-opacity']};
    max-height: 500px;
    overflow: auto;
    border-bottom: 1px solid ${colors['light-blue-200']};
  }
`

export const TemplatesList = styled.ul`
  li {
    padding: 10px;
    // margin-bottom: 5px;
    cursor: pointer;
    border-left: 3px solid transparent;
    position: relative;
    &:hover,
    &.active {
      background: #fff;
      border-left-color: ${colors['main-blue']};
    }

    &.version_history_item {
      display: flex;
      flex-direction: column;
      padding: 16px 24px;
      border-bottom: none;
      margin-bottom: 0;

      .author {
        margin-top: 5px;
        font-size: 12px;
        -webkit-text-fill-color: ${colors['text-secondary']};
        color: ${colors['text-secondary']};
      }
      .title {
        font-size: 14px;
        color: ${colors['main-text']};
      }
      .current {
        margin-left: 8px;
        font-size: 11px;
        letter-spacing: 0.03em;
        color: #ffffff;
        background: ${colors.green};
        padding: 1px 10px;
        border-radius: 24px;
        &.draft {
          background: ${colors['main-blue']};
        }
      }
    }

    .more-button-dropdown {
      position: absolute;
      right: 8px;
      top: 5px;
      button.toggle {
        @media (max-width: 1024px) {
          display: flex;
        }
        @media (min-width: 1025px) {
          display: none;
        }
      }
    }

    &:hover .more-button-dropdown button.toggle,
    &.show_delete .more-button-dropdown button.toggle {
      display: flex;
    }
  }
`

export const CategoryDropdown = styled(Dropdown)`
  width: 320px;
  .btn-toggle {
    height: 32px;
    width: 100%;
    background: none;
    border: none;
    border-bottom: 2px solid ${colors['main-blue']};
    border-radius: 0;
    &:focus,
    &:active {
      background-color: ${colors['blue-secondary']} !important;
      outline: none !important;
      box-shadow: none !important;
    }
    display: flex;
    .selected-category {
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      text-align: left;
    }
    .actionBtn {
      margin-left: auto;
      width: 50px;
      display: flex;
      justify-content: space-between;

      .expander {
        background: ${colors['light-blue-300']};
        display: flex;
        justify-content: center;
        align-items: center;
        width: 18px;
        height: 18px;
        border-radius: 16px;
      }
    }
  }
  .dropdown-menu {
    padding: 8px 0;
    border: none;
    border-radius: 0;
    width: 100%;
    box-shadow: 0px 20px 40px rgba(3, 11, 31, 0.1);
  }
`

export const CategoryAccordionItem = styled(AccordionItem)`
  padding-left: ${(props) => (props.level ? props.level * 20 - 20 : 0)}px;
  .accordionItemButton {
    display: flex;
    align-items: center;
    padding: 0 10px;
    &.active {
      background: ${colors['light-blue-100']};
    }
    .categoryName {
      padding: 8px 0;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      &:hover,
      &.active {
        background: ${colors['light-blue-100']};
      }
      svg {
        width: 18px;
        height: 18px;
      }
    }
    a:hover,
    a.active {
      font-weight: 600;
      color: ${colors['main-blue']};
    }
    .expandButton {
      border-radius: 3px;
      width: 19px;
      min-width: 19px;
      height: 19px;
      border: 1px solid ${colors['blue-100']};
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        fill: ${colors['main-text']};
      }
      &.expanded,
      &:hover {
        background: ${colors['blue-100']};
      }
    }
  }
  .AccordionItemPanel {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 18px;
      width: 1px;
      background: #c8d1e6;
    }
  }
`
export const CategoriesWithoutChild = styled.ul`
  margin-bottom: 0;
  li {
    padding: 0 5px;
    margin-left: ${(props) => (props.addMargin ? 23 : 0)}px;
    cursor: pointer;
    display: flex;
    align-items: center;
    &:hover,
    &.active {
      background-color: ${colors['light-blue-100']};
      color: ${colors['main-blue']};
      font-weight: 600;
    }
    .categoryName {
      padding: 5px 0;
      flex: 1;
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
`

export const CategoryPageOwnersAvatar = styled(Avatar)`
  // margin-left: -10px;
`

export const PageViewOptions = styled.div`
  display: flex;
  margin-left: auto;
  @media (min-width: 576px) {
    margin-right: 15px;
  }
  .dropdown {
    .toggle {
      cursor: pointer;
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
  .dropdown-menu .dropdown-item {
    cursor: pointer;
    padding: 6px 15px;
  }
  button#pageviewoption {
    font-size: 1.2rem;
    background: none;
    border: none;
    &:focus,
    &:active {
      outline: none;
    }
  }
`
export const ContentTags = styled.ul`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 0;
  li {
    border-radius: 20px;
    border: 1px solid ${colors['light-blue-300']};
    background: ${colors['lightest-blue']};
    padding: 3px 10px;
    margin-bottom: 6px;
    margin-right: 3px;
  }
`

export const Breadcrumbs = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-weight: 600;
`
export const SharedPageTitle = styled.div`
  background: #fff;
  border-right: 1px solid #e3e4ed;
  display: contents;
  @media (min-width: 576px) {
    width: ${CONSTANTS.mainMenuMinWidth}px;
    min-width: ${CONSTANTS.mainMenuMinWidth}px;
  }
  div.logo {
    margin-top: 0;
    padding: 13px 14px;
    height: 72px;
    display: flex;
    align-items: center;
    display: flex;
    align-items: center;
    .company-name {
      font-size: 23px;
      font-weight: bold;
    }
    img {
      width: auto;
      height: 25px;
      border-radius: 5px;
    }
    .has-company-logo {
      margin-right: 10px;
      min-width: 45px;
      max-width: 45px;
      height: 45px;
      display: flex;
      align-tems: center;
      justify-content: center;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
  }
  transition: transform 0.35s ease-out;
  transform: translateX(-100%);
`
export const SharedPageFooter = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 66px;
  background: #ffffff;
  z-index: 21;
  display: flex;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  div.divider {
    width: 60%;
    height: 2px;
    background-color: #e3e7f0;
  }
  .footerText {
    font-size: 16px;
    font-weight: 400;
    color: #7f82a2;
    display: flex;
    align-items: flex-end;
    gap: 0.5rem;
  }
`
export const ErrorPage404 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height:100vh;
  width: 100vw;
  flex-direction: column;
  background-color: #fff;
  gap:1.5rem;
  .text404{
    font-size: 62px;
    font-weight: 800;
  }
  .not-found{
    font-size: 24px;
    font-weight: 600;
  }
`